export default __webpack_public_path__ + "static/media/escudo_ranking2.6e4a0fa8.png";